import { ApiError } from './error';

/**
 * El contrato no define un codigo propio para "el asistente todavia no esta
 * configurado", asi que se reconoce por las senyales que si llegan: la ruta no
 * existe en el backend desplegado, el servicio contesta que no esta
 * disponible, o el mensaje lo dice explicitamente.
 */
export function isAssistantUnavailable(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;
  if (error.code === 'NOT_FOUND') return true;
  if (error.status === 501 || error.status === 503) return true;
  const message = error.message.toLowerCase();
  return /no est[aá] (configurad|disponible)|sin configurar|asistente no/.test(message);
}

/** Aviso honesto que se repite al pie de la conversacion. */
export const ASSISTANT_DISCLAIMER =
  'Alexia analiza tus datos, pero no los modifica. Revisa la información antes de tomar decisiones importantes.';
